// extracted by mini-css-extract-plugin
export default {"modal":"remStyles_modal__MyeRK","modalContent":"remStyles_modalContent__KgVOr"};